import React from 'react';
import { BringzzImage, BringzzText, BringzzButton } from "@bringzz/components";
import BringzzLogo from 'assets/BringzzLogo.png';

const PublicOverlay = ({ onSignUp, onLogin, t }) => {
  return (
    <div className="fixed bottom-4 left-4 right-4 bg-magic-lilac rounded-xl shadow-[0_-8px_30px_rgb(0,0,0,0.12)] py-4">
      <div className="max-w-xl mx-auto px-6 flex justify-between items-center">
        <div className="flex flex-col -space-y-.5">
          <BringzzImage className="h-8" src={BringzzLogo} alt="Bringzz Logo" />
          <BringzzText tag='h5' className='font-normal text-xs'>{t('overlay.since')}</BringzzText>
        </div>
        <div className="flex space-x-2 self-center">
          <BringzzButton
            size="xs"
            className="bg-midnight-blue hover:bg-opacity-90 text-white px-4 shadow-sm"
            onClick={onSignUp}
          >
            {t('overlay.sign_up')}
          </BringzzButton>
          <BringzzButton
            size="xs"
            className="border border-white text-white hover:bg-white hover:text-magic-lilac transition-colors px-4 shadow-sm"
            onClick={onLogin}
          >
            {t('overlay.login')}
          </BringzzButton>
        </div>
      </div>
    </div>
  );
};

export default PublicOverlay; 